import React, { useContext, useEffect, useState } from 'react';
import {
  OtherCertifiedIncomeContainer,
  OtherCertifiedIncomeHeader,
  OtherCertifiedIncomeHeaderInfo,
  OtherCertifiedIncomeContent
} from './styles';
import { useDropzone } from 'react-dropzone';
import InputFile from '../../../components/InputFile';
import InputIntl from '../../../components/InputIntl';
import { BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import { formatPrice } from '../../../helpers/price';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import { globalDebtSteps } from '../../../helpers/enum';
import ModalInfo from '../../../components/ModalInfo';
import { saveGlobalDebt } from '../../../services/globalDebt';
import { useHistory } from 'react-router-dom';
import { GlobalDebtContext } from '../../../store';
import { useForm } from 'react-hook-form';
import { default as GlobalDebtTypes } from '../../../store/GlobalDebt/types';
import { currencyMoney } from '../../../config/currency';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/LoaderDebt';
import Alert from '../../../components/Alert';

const OtherCertifiedIncomePage = ({ setActiveStep }) => {
  const history = useHistory();
  const { globalDebt, setGlobalDebt } = useContext(GlobalDebtContext);
  const { setValue, handleSubmit, register, watch } = useForm({ defaultValues: globalDebt.otherCertifiedIncome });
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const [canAddFile, setCanAddFile] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [titleInfoErrores, setTitleInfoErrores] = useState('');
  const fields = watch();

  function removeFile() {
    setGlobalDebt({
      type: GlobalDebtTypes.REMOVE_ARCHIVE_INCOME,
      file: []
    })
  }

  function onDrop(file) {
    setGlobalDebt({
      type: GlobalDebtTypes.SET_ARCHIVE_INCOME,
      file
    })
  }

  async function setCompleteStep() {
    try {
      const data = {
        archive: globalDebt.otherCertifiedIncome.archive,
        ingresosAdicionalesCertificados: fields.ingresosAdicionalesCertificados
      }

      setGlobalDebt({
        type: GlobalDebtTypes.SET_OTHER_CERTIFIED,
        data: data
      })

      if (parseInt(fields.ingresosAdicionalesCertificados) > parseInt(globalDebt.centralInformation.calculation?.ingresosFaltantesAproximados)){
        setTitleInfoErrores("Los Ingresos Adicionales no deben ser superiores al Ingreso Sugerido.");
        setShowModalInfo(true);
        return;
      }

      if (parseInt(fields.ingresosAdicionalesCertificados) > 0 && !globalDebt.otherCertifiedIncome.archive[0]){
        setTitleInfoErrores("Ha digitado Ingresos Adicionales. Anexe Soporte.");
        setShowModalInfo(true);
        return;
      }
      
      setIsLoading(true);

      const req = new FormData();
      req.append('save', true);
      req.append('archivo', globalDebt.centralInformation.archive[0], globalDebt.centralInformation.archive[0].name);

      if(globalDebt.otherCertifiedIncome.archive[0]) {
        req.append('archivoIngresosAdicionales', globalDebt.otherCertifiedIncome.archive[0], globalDebt.otherCertifiedIncome.archive[0].name);
      } else {
        req.append('archivoIngresosAdicionales', globalDebt.centralInformation.archive[0], globalDebt.centralInformation.archive[0].name)
      }
      
      req.append('idCredito', globalDebt.credit.id);
      req.append('idEstrato', parseInt(globalDebt.basicRequestInformation.estrato.id));
      req.append('idTipoVivienda', globalDebt.basicRequestInformation.tipoVivienda.id);
      req.append('idClaseVivienda', globalDebt.basicRequestInformation.claseVivienda.id);
      req.append('idParentesco', parseInt(globalDebt.basicRequestInformation.posicionHogar.id));
      req.append('idNivelEducativo', parseInt(globalDebt.basicRequestInformation.nivelEscolaridad.id));
      req.append('descuentosPrestacionales', parseFloat(globalDebt.solicitation.simulacion.descuentosLey));
      req.append('descuentosNomina', parseFloat(globalDebt.solicitation.simulacion.descuentosNomina));
      req.append('cuotasHipotecariasCentrales', parseFloat(globalDebt.centralInformation.cuotasHipotecarias));
      req.append('ingresosAdicionales', parseFloat(globalDebt.otherCertifiedIncome.ingresosAdicionalesCertificados));
      //req.append('codigoAdo', globalDebt.basicRequestInformation.adoSegmentCode);
      req.append('idDocumento', globalDebt.centralInformation.tipoDocumento.id);
      req.append('subCanal', "WEB");
      await saveGlobalDebt(req);

      setIsLoading(false);

      history.push({
        pathname: '/admin/means-of-disbursement',
        idCredit: globalDebt.credit.id,
      });
    } catch (error) {
      setIsLoading(false);
      console.log(error.response);
    }
  }

  useEffect(() => {
    if (globalDebt.otherCertifiedIncome.archive.length < 1) {
      setCanAddFile(true)
    } else {
      setCanAddFile(false)
    }
  }, [globalDebt.otherCertifiedIncome.archive])

  useState(() => {
    setIsLoading(false)
  }, [])

  return (
    <OtherCertifiedIncomeContainer>
      <OtherCertifiedIncomeHeader>
        <OtherCertifiedIncomeHeaderInfo>Otros ingresos certificados</OtherCertifiedIncomeHeaderInfo>
        {/*<Alert 
          warning
          description={`Endeudamiento global negativo. Ingresos sugeridos aproximados a demostrar $ ${formatPrice(parseInt(globalDebt.centralInformation.calculation?.ingresosFaltantesAproximados))}`}
        />*/}
      </OtherCertifiedIncomeHeader>
      <OtherCertifiedIncomeContent>
        <Form onSubmit={handleSubmit(setCompleteStep)} encType="multipart/form-data">
          <FormRow col="1">
            <InputIntl
              id="ingresosAdicionalesCertificados"
              label="Ingresos adicionales certificados"
              name="ingresosAdicionalesCertificados"
              defaultValue={globalDebt.otherCertifiedIncome.ingresosAdicionalesCertificados}
              register={register({ required: "Este dato es obligatorio" })}
              setValue={setValue}
              currencyConfig={currencyMoney} />
          </FormRow>
          <FormRow col="1">
          <InputFile
            getInputProps={getInputProps}
            getRootProps={getRootProps}
            canAddFile={canAddFile}
            files={globalDebt.otherCertifiedIncome.archive}
            removeFile={removeFile}
            description="Elige un archivo PNG, JPEG o JPG, o arrasta aqui." />
          </FormRow>
          <FormFooter justify="flex-end">
            <SecondaryLargeButton type="submit" id="submit" >Siguiente </SecondaryLargeButton>
          </FormFooter>
        </Form>
        {isLoading && <Loader />}
        <ModalInfo
          open={showModalInfo}
          setShowModal={setShowModalInfo}
          title={titleInfoErrores}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      </OtherCertifiedIncomeContent>
    </OtherCertifiedIncomeContainer>
  )
}

export default OtherCertifiedIncomePage
